var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"hotlink"}},[_c('PageHeader',{attrs:{"pageHeader":_vm.pageHeader,"kvTitle1Color":_vm.kvTitle1Color,"kvTitle2Color":_vm.kvTitle2Color}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }